import React from 'react';
import {connect} from 'react-redux';
import cx from 'classnames';
import {withRouter} from 'react-router-dom';

import ReactResizeDetector from 'react-resize-detector';


import AppMain from '../../Layout/AppMain';

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSmaller: window.innerWidth,
            closedSmallerSidebar: false
        };

        this.onResize = this.onResize.bind(this);
    }

    onResize() {
        this.setState({
            isSmaller: window.innerWidth,
        });

    }

    render() {
        let {
            colorScheme,
            enableFixedHeader,
            enableFixedSidebar,
            enableFixedFooter,
            enableClosedSidebar,
            closedSmallerSidebar,
            enableMobileMenu,
            enablePageTabsAlt,
        } = this.props;

        const isSmaller = this.state.isSmaller;

        if (isSmaller < 1250) {
            enableClosedSidebar = true;
            enableFixedSidebar = true;
            closedSmallerSidebar = true;
        }

        return (
            <ReactResizeDetector handleWidth onResize={this.onResize}>
                <div className={cx(
                    "app-container app-theme-" + colorScheme,
                    {'fixed-header': enableFixedHeader},
                    {'fixed-sidebar': enableFixedSidebar},
                    {'fixed-footer': enableFixedFooter},
                    {'closed-sidebar': enableClosedSidebar},
                    {'closed-sidebar-mobile': closedSmallerSidebar},
                    {'sidebar-mobile-open': enableMobileMenu},
                    {'body-tabs-shadow-btn': enablePageTabsAlt},
                )}>

                    <AppMain/>
                </div>
            </ReactResizeDetector>
        )
    }
}

const mapStateToProp = state => ({
    colorScheme: state.ThemeOptions.colorScheme,
    enableFixedHeader: state.ThemeOptions.enableFixedHeader,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
    enableFixedFooter: state.ThemeOptions.enableFixedFooter,
    enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
    enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
    enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,

});

export default withRouter(connect(mapStateToProp)(Main));


// WEBPACK FOOTER //
// ./src/DemoPages/Main/index.js